var widget_default = {
  "card": "XvW1P",
  "link": "vg1tk",
  "container": "Wwo2Q",
  "image": "ht8tf",
  "right": "ngx3H",
  "cardLayout": "MV5vJ",
  "content": "YRE8h",
  "title": "f0k6B",
  "subtitle": "Fym8P",
  "button": "DicaH",
  "button_disabled": "qJkFv",
  "buttonText": "CmM96",
  "slimLayout": "BlA8s",
  "contentText": "uaUXi"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
